export default "__VITE_ASSET__DbuTFKSV__"